// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nAKD","badges":"styles_badges__hnZ9N"};